import {
	appEnvironment,
	appEnvironmentLabel,
	firebaseEnvironment,
	firebaseEnvironmentLabel,
} from "@repo/common";
import { LogOut, Menu, PanelLeftClose, PanelLeftOpen } from "lucide-react";
import { Button } from "./ui/button";

interface NavbarProps {
	onLogout: () => void;
	isSidebarCollapsed: boolean;
	isMobileSidebarOpen: boolean;
	onToggleSidebar: () => void;
	onOpenMobileSidebar: () => void;
	userEmail: string;
	currentPage: string;
}

const pageTitles: Record<string, string> = {
	dashboard: "Overview",
	alerts: "Alerts",
	"dead-letters": "Failed events",
	"admin-tasks": "Admin tasks",
	"assisted-onboarding": "Onboarding",
	calls: "Calls",
	cogs: "COGS ledger",
	callers: "Callers",
	"caller-details": "Caller details",
	companies: "Companies",
	"company-details": "Company details",
	services: "Services",
	"service-details": "Service details",
	users: "Users",
	"user-details": "User details",
	agents: "Agents",
	"agent-details": "Agent details",
	"playbook-runs": "Playbook runs",
	"phone-numbers": "Phone numbers",
	"whatsapp-senders": "WhatsApp senders",
	"test-routing": "Test routing",
	events: "Raw events",
	tcdrs: "T-CDRs",
	"audit-logs": "Audit logs",
	logs: "LiveKit logs",
	"developer-tests": "Developer tests",
	settings: "System settings",
};

export function Navbar({
	onLogout,
	isSidebarCollapsed,
	isMobileSidebarOpen,
	onToggleSidebar,
	onOpenMobileSidebar,
	userEmail,
	currentPage,
}: NavbarProps) {
	return (
		<header className="admin-topbar">
			<div className="admin-topbar-main">
				<button
					type="button"
					className="admin-topbar-mobile-menu"
					onClick={onOpenMobileSidebar}
					aria-label="Open navigation"
					aria-controls="admin-sidebar-navigation"
					aria-expanded={isMobileSidebarOpen}
				>
					<Menu className="size-5" />
				</button>
				<button
					type="button"
					className="admin-topbar-desktop-menu"
					onClick={onToggleSidebar}
					aria-label={
						isSidebarCollapsed ? "Expand navigation" : "Collapse navigation"
					}
					aria-controls="admin-sidebar-navigation"
					aria-expanded={!isSidebarCollapsed}
				>
					{isSidebarCollapsed ? (
						<PanelLeftOpen className="size-[18px]" />
					) : (
						<PanelLeftClose className="size-[18px]" />
					)}
				</button>
				<div className="admin-topbar-identity">
					<img src="/provoize_icon.svg" alt="" className="admin-topbar-logo" />
					<div>
						<div className="admin-topbar-product">Provoize</div>
						<div className="admin-topbar-section">
							{pageTitles[currentPage] ?? "Admin"}
						</div>
					</div>
				</div>
			</div>
			<div className="admin-topbar-meta">
				<div className="admin-environments" aria-label="Environment">
					<span className="admin-environment-label">Environment</span>
					<span
						className="admin-environment-value"
						data-environment={appEnvironment}
					>
						{appEnvironmentLabel}
					</span>
					{(appEnvironment !== "production" ||
						firebaseEnvironment !== "prod") && (
						<span className="admin-firebase-value">
							Firebase: {firebaseEnvironmentLabel}
						</span>
					)}
				</div>
				<div className="admin-topbar-user" title={userEmail}>
					<span className="admin-user-avatar" aria-hidden="true">
						{userEmail.slice(0, 1).toUpperCase()}
					</span>
					<span className="admin-user-email">{userEmail}</span>
				</div>
				<Button
					variant="ghost"
					size="sm"
					onClick={onLogout}
					aria-label="Sign out"
					className="admin-topbar-logout"
				>
					<LogOut className="size-4" />
					<span>Sign out</span>
				</Button>
			</div>
		</header>
	);
}
